import { CircularProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { Field, FieldProps, useFormikContext } from 'formik';
import { TextField } from 'formik-material-ui';
import { useSnackbar } from 'notistack';
import React, { ChangeEvent, FunctionComponent, useState } from 'react';
import ApiService from '../../services/ApiService';
import useTSHacks from '../../shared/tshacks/tshacks';
import { Option } from './Option';

interface AdditionalProps {
    id: string;
    fieldName: string;
    fieldLabel: string;
    fieldOptions?: () => Option[];
    fieldValidator?: (value: any) => string;
    required?: boolean;
}

type URLFieldEditorProps = FieldProps & AdditionalProps;

const { getObjectProperty } = useTSHacks();

const URLFieldEditor: FunctionComponent<URLFieldEditorProps> = ({
    id,
    fieldLabel,
    fieldName,
    fieldValidator,
    fieldOptions,
    ...props
}) => {
    const [busy, setBusy] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { setFieldValue, values } = useFormikContext();

    const onFileChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setBusy(true);

        const file = event.target?.files?.item(0);

        ApiService()
            .uploadAsset(file)
            .then((uploadedAsset: any) => {
                setFieldValue(fieldName, uploadedAsset?.data?.publicUrl || '', true);
                enqueueSnackbar('Upload successful.', { variant: 'success' });
            })
            .catch((_reason: any) => {
                enqueueSnackbar('Upload Error.', { variant: 'error' });
            })
            .finally(() => {
                setBusy(false);
            });
    };

    return (
        <Field
            {...props}
            id={id}
            fullWidth
            display="flex"
            component={TextField}
            margin="dense"
            label={fieldLabel}
            variant="filled"
            type="url"
            name={fieldName}
            validate={fieldValidator}
            InputLabelProps={{ shrink: !!getObjectProperty(values, fieldName) }}
            InputProps={{
                endAdornment: (
                    <div>
                        {getObjectProperty(props, 'disabled') ? (
                            <div></div>
                        ) : (
                            <div>
                                <input
                                    id={'input_'.concat(id)}
                                    accept="image/*"
                                    type="file"
                                    hidden
                                    onChange={onFileChangeHandler}
                                />
                                <label htmlFor={'input_'.concat(id)}>
                                    <IconButton aria-label="upload picture" component="span">
                                        {busy ? <CircularProgress size="1em" /> : <CloudUpload />}
                                    </IconButton>
                                </label>
                            </div>
                        )}
                    </div>
                ),
            }}
        />
    );
};

export default URLFieldEditor;
